<script>
import dayjs from 'dayjs';

export default {
  name: 'CalendarCard',
  props: {
    date: {
      type: String,
    },
    events: {
      type: Array,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    today: {
      type: Boolean,
      default: false,
    },
    isUpcoming: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    getDate() {
      return dayjs(this.date).date();
    },
  },
  methods: {
    getIconSrc(icon) {
      // eslint-disable-next-line global-require,import/no-dynamic-require
      return require(`@/assets/img/${this.$chain.getName()}/launchpad/${icon}.jpg`);
    },
    getCalIcon() {
      // eslint-disable-next-line global-require,import/no-dynamic-require
      return require(`@/assets/img/${this.$chain.getName()}/ic-calendar_inverted.svg`);
    },
    calendarLink(name, time) {
      if (dayjs(this.date).isValid()) {
        const dateFormat = dayjs(this.date).format('YYYYMMDD');
        const timeStartArr = String(time)
          .toLowerCase()
          .replace(/[a-z|\s]/g, '')
          .split(':');
        const timeStart = timeStartArr
          .map((i) => (i.length < 2 ? `0${i}` : i))
          .join('')
          .slice(0, 4);
        const params = {
          action: 'TEMPLATE',
          text: name,
          dates: `${dateFormat}T${timeStart}00Z/${dateFormat}T${timeStart}00Z`,
        };
        const paramsEncoded = new URLSearchParams(params).toString();
        return `https://www.google.com/calendar/render?${paramsEncoded}`;
      }
      return '#';
    },
  },
};
</script>

<template>
  <div class="main-block calendar-card" :class="{ 'calendar-card--disabled': disabled }">
    <div class="calendar-card__title">{{ getDate }}</div>
    <div class="calendar-card__events">
      <div
        class="calendar-card__event-item"
        :class="{ 'calendar-card__event-item--today': today }"
        v-for="(event, index) in events"
        :key="index"
      >
        <img :src="getIconSrc(event.icon)" :alt="event.event" class="calendar-card__event-icon" />
        <div class="calendar-card__event-wrapper">
          <div class="calendar-card__event-time">{{ event.time }}</div>
          <div class="calendar-card__event-name">{{ event.event }}</div>
        </div>
        <div class="calendar-card__event-ical" v-if="isUpcoming">
          <a
            :href="calendarLink(event.event, event.time)"
            title="Add to Google Calendar"
            target="_blank"
            ><img
              :src="getCalIcon()"
              alt="Add to calendar icon"
              class="calendar-card__event-ical-icon"
          /></a>
        </div>
      </div>
    </div>
    <div class="calendar-card__events-mobile">
      <div class="calendar-card__event-mobile" v-for="(event, index) in events" :key="index"></div>
    </div>
    <a href="#" class="calendar-card__view-all" v-if="events.length > 1">View all</a>
  </div>
</template>

<style lang="scss" scoped>
.calendar-card {
  padding: 2rem 1rem;
  border-radius: 2rem;
  min-height: 23rem;
  position: relative;

  @media screen and (max-width: $breakpoint-sm) {
    min-height: unset;
  }

  &--disabled {
    opacity: 0.5;
  }

  &__title {
    font-size: 2.5rem;
    font-weight: 600;
    text-align: center;
    margin-bottom: 1rem;
  }

  &__events {
    @media screen and (max-width: $breakpoint-sm) {
      display: none;
    }
  }

  &__events-mobile {
    display: none;

    @media screen and (max-width: $breakpoint-sm) {
      display: flex;
      justify-content: space-around;
      flex-direction: row;
      position: absolute;
      bottom: 1.5rem;
      left: 1rem;
      right: 1rem;
      content: '';
    }
  }

  &__event-item {
    display: flex;
    margin-bottom: 0.5rem;
    padding: 0.3rem;
    font-size: 1.4rem;
    font-weight: 600;
    justify-content: space-between;

    &--today {
      background: rgba(109, 134, 246, 0.2);
      border-left: 3px solid #6d86f6;
      border-radius: 0 0.5rem 0.5rem 0;
    }
  }

  &__event-wrapper {
    margin-right: auto;
  }

  &__event-mobile {
    width: 0.6rem;
    height: 0.6rem;
    border-radius: 1rem;
    background: $main-font-color;

    body.binance {
      background: $b-main-font-color;
    }
  }

  &__event-icon {
    align-self: start;
    margin-top: 0.5rem;
    height: 3rem;
    margin-left: 0.5rem;
    margin-right: 1rem;
    border-radius: 3rem;
  }

  &__event-name {
  }

  &__event-ical {
    align-self: center;
    margin-left: 0.5rem;
    margin-top: 0.5rem;

    &-icon {
      height: 1.3em;
      width: auto;
    }
  }

  &__event-time {
    color: $grey-font-color;

    body.binance {
      color: $b-grey-font-color;
    }
  }

  &__view-all {
    display: block;
    text-align: center;
    font-size: 1.4rem;
    font-weight: 600;
    margin-top: 2rem;
    text-transform: uppercase;
    text-decoration: none;
    color: $grey-font-color;

    body.binance {
      color: $b-grey-font-color;
    }

    @media screen and (max-width: $breakpoint-lg) {
      display: none;
    }
  }
}
</style>
